module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/cirrus-aa086d598e5f3cccf88ad75b3dbb3eab.png";